import NotAuthorizedUser from './NotAuthorizedUser';

export default NotAuthorizedUser;
